<template>
  <div>
    <b-modal :id="id" :title="$t('application.new')" size="lg" @hide="closeModal" hide-footer>
      <div class="row">
        <div class="col-md-6">
          <h6>{{ $t("product.text") }}</h6>
          <select class="form-control " v-model="form.product" :disabled="currentProduct">
            <option v-for="item in products" :key="item" :value="item">{{ item }}</option>
          </select>

          <h6 class="mt-3">
            {{ $t("application.category.text") }}
          </h6>

          <right-panel
            class="float-right"
            id="sidebar-new-application-category"
            width="650px"
            :icon="'mdi mdi-plus'"
            :text="$t('application.category.new')"
            @hidden="rightPanelClosed"
          >
            <div class="pl-5 pr-5">
              <CategoryForm />
            </div>
          </right-panel>

          <filter-select
            class="mt-4"
            id="applicationCategoryFilter"
            ref="applicationCategoryFilter"
            :selected="form.category"
            :placeholder="$t('application.category.text')"
            :multiple="true"
            @filter="onApplicationCategorySearch"
            @changed="onApplicationCategorySelect"
          />
          <br />
          <h6>{{ $t("application.subject") }}</h6>

          <textarea v-model="form.applicationSubject" type="text" class="form-control" :placeholder="$t('common.description')" rows="2"></textarea>
          <sweet-input
            v-model="form.firstAndLastName"
            :isValid="!$v.form.firstAndLastName.$error"
            @input="$v.form.firstAndLastName.$touch()"
            layout="vertical"
            :placeholder="$t('auth.placeholder.name-surname')"
            :label="$t('common.name-surname2')"
            class="mt-3"
          />
          <sweet-input
            v-model="form.idNo"
            :isValid="!$v.form.idNo.$error"
            @input="$v.form.idNo.$touch()"
            layout="vertical"
            :placeholder="$t('application.auth.no')"
            :label="$t('application.no')"
            class="mt-3"
          />
          <sweet-input
            v-model="form.phone"
            :isValid="!$v.form.phone.$error"
            @input="$v.form.phone.$touch()"
            layout="vertical"
            :placeholder="$t('application.auth.phone')"
            :label="$t('application.phone')"
            class="mt-3"
          />
          <sweet-input
            :isValid="!$v.form.email.$error"
            @input="$v.form.email.$touch()"
            v-model="form.email"
            type="email"
            layout="vertical"
            inputClass="mt"
            :placeholder="$t('auth.placeholder.email')"
            :label="$t('common.email')"
            class="mt-3"
          />
          <sweet-input
            v-model="form.adress"
            :isValid="!$v.form.adress.$error"
            @input="$v.form.adress.$touch()"
            layout="vertical"
            :placeholder="$t('application.auth.adress')"
            :label="$t('application.adress')"
            class="mt-3"
          />
          <br />
          <h6>{{ $t("application.method") }}</h6>

          <filter-select
            id="applicationMethodFilter"
            ref="applicationMethodFilter"
            :selected="form.applicationMethod"
            :placeholder="$t('')"
            :multiple="false"
            @filter="onApplicationMethodSearch"
            @changed="onApplicationMethodSelect"
            track="definition"
          />
          <br />
        </div>

        <div class="col-md-6">
          <h6>{{ $t("application.department") }}</h6>

          <filter-select
            id="applicationDepartmentFilter"
            ref="applicationDepartmentFilter"
            :selected="form.department"
            :placeholder="$t('application.auth.department')"
            :multiple="false"
            @filter="onApplicationDepartmentSearch"
            @changed="onApplicationDepartmentSelect"
          />

          <br />
          <h6>{{ $t("application.relation") }}</h6>

          <filter-select
            id="relationshipFilter"
            ref="relationshipFilter"
            :selected="form.relationship"
            :placeholder="$t('application.auth.relation')"
            :multiple="false"
            @filter="onRelationshipSearch"
            @changed="onRelationshipSelect"
            track="definition"
          />
          <br />
          <h6>{{ $t("application.date") }}</h6>
          <date-picker
            v-model="form.applicationDate"
            :first-day-of-week="1"
            lang="lang"
            format="DD.MM.YYYY"
            value-type="timestamp"
            :placeholder="$t('application.auth.application-date')"
          />

          <br />
          <br />
          <h6>{{ $t("application.deadline-date") }}</h6>
          <date-picker
            v-model="form.deadlineDate"
            :first-day-of-week="1"
            lang="tr"
            format="DD.MM.YYYY"
            value-type="timestamp"
            :placeholder="$t('application.auth.deadline-date')"
          />
          <br />
          <br />
          <h6>{{ $t("application.priority") }}</h6>

          <filter-select
            id="PriorityFilter"
            ref="PriorityFilter"
            :selected="form.priority"
            :placeholder="$t('')"
            :multiple="false"
            @filter="onPrioritySearch"
            @changed="onPrioritySelect"
            track="definition"
          />
          <br />

          <h6>{{ $t("application.situation") }}</h6>

          <filter-select
            id="SituationFilter"
            ref="SituationFilter"
            :selected="form.situation"
            :placeholder="$t('')"
            :multiple="false"
            @filter="onSituationSearch"
            @changed="onSituationSelect"
            track="definition"
          />
          <br />
          <h6>{{ $t("application.note") }}</h6>

          <textarea v-model="form.applicationNote" type="text" class="form-control" :placeholder="$t('common.description')" rows="2"></textarea>
          <br />

          <b-form-checkbox switch class="custom-checkbox mb-3" v-model="form.isTask">
            {{ $t("application.auth.isTask") }}
          </b-form-checkbox>

          <div v-if="form.isTask">
            <h6>{{ $t("application.appointed-account") }}</h6>

            <filter-select
              id="AccountFilter"
              ref="AccountFilter"
              :selected="form.appointedAccount"
              :placeholder="$t('')"
              :multiple="false"
              @filter="onAccountSearch"
              @changed="onAccountSelect"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div v-if="form._id">
            <button class="link-button mb-3" v-b-toggle.collapse-file-rocket><i class="iconoir-attachment"></i> {{ $t("file-manager.attach") }}</button>
            <b-collapse id="collapse-file-rocket" class="mt-2">
              <file-rocket
                :multiple="true"
                :allowedFormats="allowedFormats"
                @response="handleUploadResponse"
                :showProgress="'Upload'"
                :maxFileSize="600000000000"
                :maxFileLength="5"
                :targetUrl="targetUrl"
              >
              </file-rocket>
            </b-collapse>
          </div>

          <div v-if="form.files && form.files.length > 0">
            <div class="d-flex align-items-center">
              <div class="tab2 mt-4 " :class="{ active: true }">
                {{ $t("file-manager.files") }}
                <span>({{ form.files.length }})</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 d-flex" v-for="file in paginatedFileData" :key="file._id">
                <div class="card shadow-none">
                  <div class="card-body text-center d-flex align-items-center flex-column">
                    <div v-b-tooltip.hover :title="$options.filters.translate(file.name)" class="mb-2">
                      <file-icon :extension="file.extension" />
                      <!--  <i :class="getIconClass(file.extension)" style="font-size:2rem;"></i>-->
                      <p class="card-text">{{ file.name | translate | summary(15) }}</p>
                    </div>
                    <div class="mt-auto">
                      <i
                        @click="downloadFile(file)"
                        v-b-tooltip.hover
                        :title="$t('file-manager.download')"
                        class="bx bxs-download text-dark hand mr-2"
                        style="font-size:1.2rem;"
                      ></i>
                      <i @click="deleteFile(file)" v-b-tooltip.hover :title="$t('common.delete')" class="bx bx-trash text-danger hand" style="font-size:1.2rem;"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-pagination
              class="mt-2"
              v-if="form.files.length > filePagination.perPage"
              v-model="filePagination.currentPage"
              :total-rows="form.files.length"
              :per-page="filePagination.perPage"
              limit="5"
              size="sm"
            ></b-pagination>
          </div>
        </div>
      </div>
      <div class="text-center">
        <sweet-button
          @click="save()"
          type="submit"
          :disabled="isUpdating || $v.$invalid || (form.isTask && !form.appointedAccount)"
          :loading="isUpdating"
          variant="success"
          icon="mdi mdi-check"
          size="sm"
          buttonClass="mt-2"
        >
          {{ $t("common.save") }}
        </sweet-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import FileRocket from "@c/form/file-rocket";
import FileIcon from "@modules/file-manager/file-icon.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/tr";
import ApplicationMethod from "./enum/ApplicationMethod.json";
import Priority from "./enum/Priority.json";
import Relationship from "./enum/Relationship.json";
import Situation from "./enum/Situation.json";
import CategoryForm from "./workspace-library-application-category-form";

import { email, maxLength, minLength, required, requiredIf } from "vuelidate/lib/validators";
export default {
  props: ["id"],
  components: {
    DatePicker,
    FileRocket,
    FileIcon,
    CategoryForm,
  },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15 },
        query: {},
      },
      filePagination: {
        currentPage: 1,
        perPage: 4,
      },
      form: {
        category: undefined,
        applicationSubject: undefined,
        firstAndLastName: undefined,
        idNo: undefined,
        applicationMethod: undefined,
        department: undefined,
        relationship: undefined,
        applicationDate: undefined,
        deadlineDate: undefined,
        situation: undefined,
        applicationNote: undefined,
        isTask: false,
        appointedAccount: undefined,
        priority: undefined,
        phone: undefined,
        lang: "tr",
        product: undefined,
      },
      allowedFormats: ["application/*", "image/*", "text/*"],
    };
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        if (this.form && this.form.applicationDate && this.form.deadlineDate) {
          this.form.applicationDate = new Date(this.form.applicationDate).getTime();
          this.form.deadlineDate = new Date(this.form.deadlineDate).getTime();
        }
        if (this.form.isTask == null) {
          this.form.isTask = false;
        }

        if (!this.form.product) {
          this.form = { ...this.form, product: this.currentProduct };
        }
      },
    },
    "form.product": {
      deep: true,
      immediate: true,
      handler(n, o) {
        //if old and new value is not equals
        if (n !== o) {
          this.$refs["applicationCategoryFilter"]?.reset();
        }
      },
    },
    "form.applicationDate": {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if (!newValue) {
          const now = new Date();
          const deadlineDate = new Date(now);
          deadlineDate.setDate(now.getDate() + 30);
          this.form.applicationDate = now.getTime();
          this.form.deadlineDate = deadlineDate.getTime();
        } else {
          const applicationDate = new Date(newValue);
          const deadlineDate = new Date(applicationDate);
          deadlineDate.setDate(applicationDate.getDate() + 30);
          this.form.deadlineDate = deadlineDate.getTime();
        }
      },
    },
  },
  validations: {
    form: {
      product: { required },

      applicationSubject: {
        required,
      },
      firstAndLastName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      idNo: {
        required,
        minLength: minLength(11),
        maxLength: maxLength(11),
        containsOnlyNumbers: function(value) {
          return /^[0-9*#Xx\-_]+$/.test(value);
        },
      },
      applicationMethod: {
        required,
      },
      department: {
        required,
      },
      relationship: {
        required,
      },
      applicationDate: {
        required,
      },
      deadlineDate: {
        required,
      },
      situation: {
        required,
      },
      applicationNote: {
        required,
      },
      appointedAccount: {
        required: requiredIf(function(form) {
          return form.isTask;
        }),
      },

      priority: {
        required,
      },
      phone: {
        required,
        containsOnlyNumbersAndPlus: function(value) {
          return /^[0-9+*#Xx\-_]+$/.test(value);
        },
      },
      email: { lowercase: (value) => value === value?.toLowerCase(), required, email },
      adress: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters["account/isLoading"];
    },
    isUpdating() {
      return this.$store.getters["account/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["application/editedEntity"];
    },
    selectedOrganization() {
      return this.$store.getters["organization/selected"];
    },
    targetUrl() {
      return `application/${this.form._id}/upload`;
    },
    isUploading() {
      return this.$store.getters["fileManager/isUploading"];
    },
    selectedEntity() {
      return this.$store.getters["application/selectedEntity"];
    },
    paginatedFileData() {
      const start = (this.filePagination.currentPage - 1) * this.filePagination.perPage;
      const end = start + this.filePagination.perPage;
      return this.form.files.slice(start, end);
    },
  },
  mounted() {
    if (this.currentProduct) {
      this.form.product = this.currentProduct;
    }
  },
  methods: {
    rightPanelClosed() {
      if (this.$refs.applicationCategoryFilter) {
        this.$refs.applicationCategoryFilter.reset();
      }
    },
    async reloadWithId(id) {
      await this.findById(id);
      this.$store.commit("application/editedEntity", { ...this.selectedEntity });
    },
    async handleUploadResponse(event) {
      if (!this.isUploading) {
        if (event && event?.status !== 200) {
          this.$handleHttpErrorByStatusCode(event?.error);
        }
        await this.reloadWithId(this.form._id);
      }
    },
    findById(id) {
      return this.$store.dispatch("application/findById", id);
    },
    downloadFile(file) {
      this.$store.commit("fileManager/addDownloadedFile", { file });
    },
    async deleteFile(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("fileManager/delete", item._id);
        this.reloadWithId(this.form._id);

        this.$toast.success(`${this.$t("common.delete-successful")} [${this.$options.filters.translate(item.name)}]`);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: `${this.$t("common.delete-fail")} [${this.$options.filters.translate(item.name)}]` });
      }
    },
    async save() {
      try {
        if (this.currentProduct) {
          this.form.product = this.currentProduct;
        }
        const response = await this.$store.dispatch(`application/save`, this.form);
        this.$toast.success(this.$t("common.success"));
        await this.reloadWithId(response.data._id);

        this.$emit("onSent");
        this.$root.$emit("bv::toggle::modal", "application-form-modal");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onApplicationCategorySearch(value, callback) {
      if (this.form.product) {
        const response = await this.$store.dispatch(`applicationCategory/paginate`, {
          options: { limit: 200 },
          query: {
            products: { value: this.form.product, isObject: true },
            name: { value },
          },
        });

        callback(response.data?.docs ?? []);
      }
    },

    onApplicationCategorySelect(category) {
      this.form = { ...this.form, category };
    },
    async onApplicationDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },

    onApplicationDepartmentSelect(department) {
      this.form = { ...this.form, department };
    },

    async onApplicationMethodSearch(value, callback) {
      const response = ApplicationMethod;

      callback(response);
    },
    onApplicationMethodSelect(item) {
      this.form = { ...this.form, applicationMethod: item };
    },
    async onRelationshipSearch(value, callback) {
      const response = Relationship;

      callback(response);
    },
    onRelationshipSelect(relationship) {
      this.form = { ...this.form, relationship };
    },
    async onPrioritySearch(value, callback) {
      const response = Priority;

      callback(response);
    },
    onPrioritySelect(priority) {
      this.form = { ...this.form, priority };
    },
    async onSituationSearch(value, callback) {
      const response = Situation;

      callback(response);
    },
    onSituationSelect(situation) {
      this.form = { ...this.form, situation };
    },
    async onAccountSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationMember/paginateWith`, {
        pagination: {
          options: { limit: 200 },
          query: { name: { value }, accessable: { value: true, isObject: true } },
        },
        organizationId: this.selectedOrganization?._id,
      });
      callback(response.data.docs ?? []);
    },

    onAccountSelect(appointedAccount) {
      if (appointedAccount) {
        this.form = { ...this.form, appointedAccount: { _id: appointedAccount.accountId ?? appointedAccount._id, name: appointedAccount.name } };
      } else {
        this.form = { ...this.form, appointedAccount };
      }
    },

    closeModal() {
      this.form.isTask = false;
      this.$store.commit("application/editedEntity", null);
    },
  },
};
</script>
